import skillDataList from "./../data/skill-data.js";

const SkillsItem = ({ component, link, color }) => {
  return (
    <li className="skills__item" target="_blank">
      <a
        href={link}
        className="skills__link"
        target="_blank"
        rel="noreferrer"
        style={{ "--hover-color": color }}
      >
        {component}
      </a>
    </li>
  );
};

const Skills = () => {
  return (
    <div className="section skills">
      <h1 className="large-text" data-drop-text="Skills">
        Skills
      </h1>
      <p className="small-text">What I've worked with</p>
      <div className="skills__list">
        {skillDataList.map(({ component, link, color }, idx) => (
          <SkillsItem
            key={idx}
            component={component}
            link={link}
            color={color}
          />
        ))}
      </div>
    </div>
  );
};

export default Skills;
